import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionHeading } from "@/components/Bits";

export function Journal() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/journal").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 pt-14 pb-24">
      <SectionHeading eyebrow="The ASURE Journal" title="Notes on nutrition, ingredients & everyday wellness" />
      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
        {items.map((a) => (
          <Link key={a.slug} to={`/journal/${a.slug}`} className="group block" data-testid={`article-${a.slug}`}>
            <div className="product-media aspect-[4/3]"><img src={a.hero} alt={a.title} className="w-full h-full object-cover" /></div>
            <div className="mt-4"><div className="eyebrow">{a.category}</div>
              <h3 className="font-display text-2xl mt-2 leading-tight">{a.title}</h3>
              <p className="text-sm text-asure-text2 mt-2">{a.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
export default Journal;
